export class PessoaFisicaFiltroParmDTO {
  parteNome: string;
  medico: boolean;
  usuario: boolean;
}